import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { RankingHeader } from '@features/rankings/models/ranking.model'
import { HeaderComponent } from '@shared/components/header/header.component'
import { TemplateDirective } from '@shared/directives/mcm-template.directive'
import { NgClass } from '@angular/common'
import { DefaultImageModule } from '@mediacoach/ui'
import { ButtonComponent } from '@shared/components/button/button.component'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'mcm-ranking-header',
  templateUrl: './ranking-header.component.html',
  styleUrls: ['./ranking-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, TemplateDirective, NgClass, DefaultImageModule, ButtonComponent, TranslatePipe]
})
export class RankingHeaderComponent {
  readonly header = input<RankingHeader>(undefined)
  readonly closeModal = output<void>()
}
